<div class="ui segments">
  <div
    class="ui segment"
    style="border-top-left-radius: 8px; border-top-right-radius: 8px"
  >
    <div
      style="padding: 5px; font-size: 14px; word-wrap: nowrap"
      class="segment-header"
    >
      Company Documents & Other Details
    </div>
  </div>
  <div
    class="ui gray segment"
    [ngClass]="{ loading: pending || loading }"
    style="
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      min-height: 400px;
      width: 100%;
      overflow: auto;
    "
  >
    <div
      style="height: 97px; width: 100%"
      class="ui default border-grey message"
      *ngIf="ownershipType !== 'foreign_owned'"
    >
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">
          OFFICIAL DOCUMENTS
        </h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <span
            style="
              color: #979797;
              font-size: 14px;
              position: relative;
              top: 15px;
              font-weight: 500;
            "
            *ngIf="companyRecord?.documents !== 0; else no_document"
          >
            <div class="ui circular button blue">
              {{ companyRecord?.documents }}
            </div>
            Verified Documents
          </span>
          <ng-template #no_document>
            <span
              style="
                color: #979797;
                font-size: 14px;
                top: 15px;
                position: relative;
                font-weight: 500;
              "
            >
              <div class="ui circular button gray">0</div>
              Verified Documents
            </span>
          </ng-template>
          <a
            style="position: relative; top: 0.9rem"
            routerLink="/contractor/company/document/official"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
    <div
      style="height: 97px; width: 100%"
      class="ui default border-grey message"
      *ngIf="isBusinessName"
    >
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">PROPRIETORS</h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <span
            style="
              color: #979797;
              font-size: 14px;
              position: relative;
              top: 15px;
              font-weight: 500;
            "
            *ngIf="
              companyRecord?.ownershipTypes['proprietor'] !== 0 ||
                companyRecord?.ownershipTypes['Proprietor'] !== 0;
              else no_proprietors
            "
          >
            <div class="ui circular button blue">
              {{
                companyRecord?.ownershipTypes["proprietor"] ||
                  companyRecord?.ownershipTypes["Proprietor"]
              }}
            </div>
            Verified Proprietors
          </span>
          <ng-template #no_proprietors>
            <span
              style="
                color: #979797;
                font-size: 14px;
                top: 15px;
                position: relative;
                font-weight: 500;
              "
            >
              <div class="ui circular button gray">0</div>
              Verified Proprietors
            </span>
          </ng-template>
          <a
            style="position: relative; top: 0.9rem"
            routerLink="/contractor/company/ownership-structure/verified"
            [queryParams]="{
              typeId: allAffiliateTypes.optionId,
              typeName: 'Proprietor'
            }"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
    <div
      style="height: 97px; width: 100%"
      class="ui default border-grey message"
      *ngIf="!isBusinessName"
    >
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">DIRECTORS</h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <span
            style="
              color: #979797;
              font-size: 14px;
              position: relative;
              top: 15px;
              font-weight: 500;
            "
            *ngIf="
              companyRecord?.ownershipTypes['Director'] !== 0;
              else no_directors
            "
          >
            <div class="ui circular button blue">
              {{ companyRecord?.ownershipTypes["Director"] || 0 }}
            </div>
            Verified Directors
          </span>
          <ng-template #no_directors>
            <span
              style="
                color: #979797;
                font-size: 14px;
                top: 15px;
                position: relative;
                font-weight: 500;
              "
            >
              <div class="ui circular button gray">0</div>
              Verified Directors
            </span>
          </ng-template>
          <a
            style="position: relative; top: 0.9rem"
            routerLink="/contractor/company/ownership-structure/verified"
            [queryParams]="{
              typeId: 'director_type',
              typeName: 'Director'
            }"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
    <div
      style="height: 97px; width: 100%"
      class="ui default border-grey message"
      *ngIf="!isBusinessName"
    >
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">
          SHAREHOLDERS
        </h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <span
            style="
              color: #979797;
              font-size: 14px;
              position: relative;
              top: 15px;
              font-weight: 500;
            "
            *ngIf="
              companyRecord?.ownershipTypes['Shareholder'] !== 0;
              else no_shareholders
            "
          >
            <div class="ui circular button blue">
              {{ companyRecord?.ownershipTypes["Shareholder"] || 0 }}
            </div>
            Verified Shareholders
          </span>
          <ng-template #no_shareholders>
            <span
              style="
                color: #979797;
                font-size: 14px;
                top: 15px;
                position: relative;
                font-weight: 500;
              "
            >
              <div class="ui circular button gray">0</div>
              Verified Shareholders
            </span>
          </ng-template>
          <a
            style="position: relative; top: 0.9rem"
            routerLink="/contractor/company/ownership-structure/verified"
            [queryParams]="{
              typeId: 'shareholder_type',
              typeName: 'Shareholder'
            }"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
    <div
      style="height: 97px; width: 100%"
      class="ui default border-grey message"
      *ngIf="!isBusinessName"
    >
      <div style="position: relative; top: 0.1rem" class="details">
        <h3 style="position: relative" class="mini-card header">
          COMPANY SECRETARIES
        </h3>
        <div
          style="
            display: flex;
            justify-content: space-between;
            height: 10px;
            position: relative;
            bottom: 23px;
            margin-top: 15px;
            margin-bottom: 10px;
          "
          class="link-flex"
        >
          <span
            style="
              color: #979797;
              font-size: 14px;
              position: relative;
              top: 15px;
              font-weight: 500;
            "
            *ngIf="
              companyRecord?.ownershipTypes['Company Secretary'] !== 0;
              else no_secetaries
            "
          >
            <div class="ui circular button blue">
              {{ companyRecord?.ownershipTypes["Company Secretary"] || 0 }}
            </div>
            Verified Company Secretaries
          </span>
          <ng-template #no_secetaries>
            <span
              style="
                color: #979797;
                font-size: 14px;
                top: 15px;
                position: relative;
                font-weight: 500;
              "
            >
              <div class="ui circular button gray">0</div>
              Verified Company Secretaries
            </span>
          </ng-template>
          <a
            style="position: relative; top: 0.9rem"
            routerLink="/contractor/company/ownership-structure/verified"
            [queryParams]="{
              typeId: 'company secretary_type',
              typeName: 'Company Secretary'
            }"
            ><i class="angle right large link icon"></i
          ></a>
        </div>
      </div>
    </div>
  </div>
</div>
